export const colorShades = [
  50, 100, 200, 300, 400, 500, 600, 700, 800, 900, 950,
] as const;
export type ColorShade = (typeof colorShades)[number];

export const getClosestColorShade = (color: number) => {
  return colorShades.reduce((prev: ColorShade, curr: ColorShade) =>
    Math.abs(curr - color) < Math.abs(prev - color) ? curr : prev,
  );
};

export const buildColorPalette = (color: string) => {
  return Object.fromEntries(
    colorShades.map((shade: ColorShade) => [shade, `{${color}.${shade}}`]),
  ) as Record<ColorShade, string>;
};
